export const CHECKIN_SESSION_KEYS = {
  SEARCH_TYPE: 'checkinSearchType',
  ETICKET_NUMBER: 'checkinETicketNumber',
  SKYMILES_NUMBER: 'checkinSkymilesNumber',
  LAST_NAME: 'checkinLastName',
  CONFIRMATION_NUMBER: 'checkinConfirmationNumber',
  DEPARTURE_AIRPORT: 'checkinDepartureAirport',
  START_FROM: 'checkinStartFrom',
  DEEP_LINK_FLOW: 'deepLinkFlow'
};

export const CHECKIN_SEARCH_TYPE_MAP: Record<string, string> = {
  CONFIRMATION: 'confirmationInput',
  TICKET: 'eticketInput',
  LOYALTYNUM: 'skymilesInput',
  CREDITCARD: 'creditCardInput'
};

export const CONFIRMATION = 'CONFIRMATION';

export const CHECKIN_START_FROM = {
  MY_TRIP: 'mytrip'
};

export const CHECKIN_CONFIG = {
  SECTION: 'MY_TRIPS',
  AWS_URL_KEY: 'CHECK_IN_AWS_URL'
};
